module.exports = __webpack_public_path__ + "img/es.45957a4c.png";